module.exports = __webpack_public_path__ + "static/media/traffic_branco.d785096a.png";